import React, { useState, useMemo } from "react";

// Collections list with search functionality
const CollectionsList = ({
    collections,
    selectedName,
    onSelect,
    loading,
    displayMode = false,
}) => {
    const [hoveredName, setHoveredName] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    const filteredCollections = useMemo(() => {
        if (!searchQuery.trim()) return collections;
        try {
            // Escape special regex characters for safety, then create regex pattern
            const escapedQuery = searchQuery.replace(
                /[.*+?^${}()|[\]\\]/g,
                "\\$&",
            );
            const regex = new RegExp(escapedQuery, "i"); // 'i' for case-insensitive
            return collections.filter((name) => regex.test(name));
        } catch (error) {
            // If regex is invalid, fall back to simple search
            return collections.filter((name) =>
                name.toLowerCase().includes(searchQuery.toLowerCase()),
            );
        }
    }, [collections, searchQuery]);

    return (
        <div
            className={`border-r border-border bg-background flex flex-col h-full shadow-sm ${
                displayMode ? "w-[420px] min-w-[420px] p-5" : "w-[400px] p-4"
            }`}
        >
            <div className="mb-3 pb-3 border-b-2 border-border">
                <div className="flex items-center justify-between gap-2 mb-2">
                    <h3
                        className={`mt-0 mb-0 text-foreground font-bold tracking-tight ${
                            displayMode ? "text-[18px]" : "text-sm"
                        }`}
                    >
                        Collections
                    </h3>
                    <div
                        className={`text-muted-foreground font-medium ${
                            displayMode ? "text-[15px]" : "text-[11px]"
                        }`}
                    >
                        {collections.length}
                    </div>
                </div>
                <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className={`w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all ${
                        displayMode ? "text-[16px]" : "text-xs"
                    }`}
                />
            </div>
            {loading ? (
                <div
                    className={`text-muted-foreground flex items-center gap-2 ${
                        displayMode ? "text-[16px]" : "text-xs"
                    }`}
                >
                    <div className="w-4 h-4 border-2 border-border border-t-muted-foreground rounded-full animate-spin"></div>
                    Loading...
                </div>
            ) : (
                <div className="overflow-y-auto pr-1 flex-1 app-scrollbar">
                    {filteredCollections.length === 0 ? (
                        <div className="text-muted-foreground text-xs text-center py-4">
                            No collections found
                        </div>
                    ) : (
                        filteredCollections.map((name) => {
                            const isSelected = selectedName === name;
                            const isHovered = hoveredName === name;
                            return (
                                <div
                                    key={name}
                                    onClick={() => onSelect(name)}
                                    onMouseEnter={() => setHoveredName(name)}
                                    onMouseLeave={() => setHoveredName(null)}
                                    className={`rounded-lg cursor-pointer mb-1.5 transition-all duration-200 ease-in-out ${
                                        displayMode
                                            ? "p-4 text-[17px] leading-snug"
                                            : "p-3 text-[13px]"
                                    }
                  ${
                      isSelected
                          ? "bg-primary text-primary-foreground font-bold shadow-md translate-x-0.5 border border-primary/20"
                          : isHovered
                            ? "bg-muted text-foreground font-semibold"
                            : "bg-transparent text-foreground font-semibold border border-transparent"
                  }
                `}
                                >
                                    <div className="flex items-center gap-2">
                                        <div
                                            className={`w-2 h-2 rounded-full transition-all duration-200
                    ${isSelected ? "bg-primary-foreground opacity-100" : "bg-muted-foreground opacity-40"}
                  `}
                                        ></div>
                                        <div className="flex-1">{name}</div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            )}
        </div>
    );
};

export default CollectionsList;
